module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-60-min.6cbf0794.jpg";